import "./App.css";
import React from "react";
import Navbar from "./components/NavbarFooter/Navbar";
import Hero from "./components/Hero";
import Footer from "./components/NavbarFooter/Footer";
import AboutUs from "./components/AboutUs";
import GearsSection from "./components/Gears/GearsSection";
import AdBannerCard from "./components/AdBanner/AdBannerCard";
import ClientsSection from "./components/Clients/ClientSection";
import TestimonialSection from "./components/Clients/TestimonialSection";
import WhatsAppFloatButton from "./components/WhatsAppFloatButton";

import StudioSection from "./components/Studio/StudioSection";
import TalentsSection from "./components/Talents/TalentsSection";
import VideoStudios from "./components/StudioVideo/StudioVideos";

function App() {
  
  return (
    <>
      <Navbar />
      <Hero />
      <AboutUs />
      <GearsSection />
      <AdBannerCard
        imageUrl="https://images.unsplash.com/photo-1516035069371-29a1b244cc32?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Y2FtZXJhfGVufDB8fDB8fHww&auto=format&fit=crop&w=1600&q=80"
        title="Premium Equipment Rentals"
        subtitle="Book now and get 20% off your first rental"
        ctaText="Explore Gear"
        onCtaClick={() => console.log("CTA clicked")}
      />

      <ClientsSection />
      <VideoStudios/>
      
      <TestimonialSection />
      <WhatsAppFloatButton />

      <Footer />
    </>
  );
}
export default App;
